/** @jsxImportSource @emotion/react */
import React from "react";
import { StyledText } from "../assets/typography/typography";
import { css } from "@emotion/react";
import { colors } from "./colors";

type Props = {
  imageUrl?: string;
  file?: any;
  children?: React.ReactNode;
  size?: "small" | "medium" | "large";
  rounded?: boolean;
  backgroundColor?: string;
};

export const Avatar = ({
  imageUrl,
  children,
  file,
  rounded = true,
  backgroundColor,
  size = "small",
}: Props) => {
  const outerSizeStyle = css`
    display: flex;
    border-radius: ${rounded ? "9999px" : "8px"};
    align-items: center;
    background-color: ${colors.white};
    justify-content: center;
    border: 1px solid ${colors.greyBorder};
    padding: 4px;
    height: ${size === "small" ? "32px" : size === "medium" ? "40px" : "48px"};
    width: ${size === "small" ? "32px" : size === "medium" ? "40px" : "48px"};
    min-height: ${size === "small"
      ? "32px"
      : size === "medium"
      ? "40px"
      : "48px"};
    min-width: ${size === "small"
      ? "32px"
      : size === "medium"
      ? "40px"
      : "48px"};
  `;

  const innerSizeStyle = css`
    display: flex;
    align-items: center;
    object-fit: cover;
    text-align: center;
    object-fit: cover;
    justify-content: center;
    background-color: ${backgroundColor ? backgroundColor : colors.whiteHover};
    border-radius: ${rounded ? "9999px" : "4px"};
    height: ${size === "small" ? "24px" : size === "medium" ? "32px" : "40px"};
    width: ${size === "small" ? "24px" : size === "medium" ? "32px" : "40px"};
    min-height: ${size === "small"
      ? "24px"
      : size === "medium"
      ? "32px"
      : "40px"};
    min-width: ${size === "small"
      ? "24px"
      : size === "medium"
      ? "32px"
      : "40px"};
  `;
  let src = imageUrl;
  if (file) {
    src = file;
  }

  return (
    <div css={outerSizeStyle}>
      {src ? (
        <img css={innerSizeStyle} src={src} alt="avatar" />
      ) : (
        <div css={innerSizeStyle}>
          <StyledText
            className="bodyTextRegular mb-0"
            color={colors.textPrimary}
          >
            {children}
          </StyledText>
        </div>
      )}
    </div>
  );
};
